/* eslint-disable quotes */
/* eslint-disable comma-dangle */
/* eslint-disable semi */
import Layout from "@/layout";

const outstandingAmount = {
  path: "/outstandingAmount",
  component: Layout,
  alwaysShow: true, // will always show the root menu
  name: "outstandingAmount",
  meta: {
    title: "미납 관리",
    icon: "search",
  },
  children: [
    {
      path: "processPayment",
      component: () =>
        import("@/views/defaultProcess/ProcessCarAndDownloadManage.vue"),
      name: "processPayment",
      meta: {
        title: "미납내역 관리",
      },
    },
    {
      path: "defaultProcess",
      component: () => import("@/views/defaultProcess/index.vue"),
      // component: () => import("@/views/defaultProcess/DefaultProcessing.vue"),
      name: "defaultProcess",
      meta: {
        title: "미납처리",
      },
      children: [
        {
          path: "groupProcess",
          component: () =>
            import(
              "@/views/defaultProcess/defaultGroup/DefaultProcessGroup.vue"
            ),
          name: "groupProcess",
          meta: {
            title: "그룹처리",
          },
        },
        {
          path: "EachProcess",
          component: () =>
            import("@/views/defaultProcess/DefaultProcessing.vue"),
          name: "EachProcess",
          meta: {
            title: "개별처리",
          },
        },
        {
          path: "groupProcessDrop",
          component: () =>
            import(
              "@/views/defaultProcess/defaultGroup/DefaultProcessDropGroup.vue"
            ),
          name: "groupProcessDrop",
        },
        {
          path: "groupProcessDown",
          component: () =>
            import(
              "@/views/defaultProcess/defaultGroup/DefaultProcessDownGroup.vue"
            ),
          name: "groupProcessDown",
        },
        {
          path: "groupProcessDetail",
          component: () =>
            import(
              "@/views/defaultProcess/defaultGroup/detail/DefaultProcessGroupDetail.vue"
            ),
          name: "groupProcessDetail",
        },
        {
          path: "processCarDetail",
          component: () =>
            import(
              "@/views/defaultProcess/detail/ProcessCarAndDownloadDetail.vue"
            ),
          name: "processCarDetail",
        },
      ],
    },
    {
      path: "tenantProcess",
      alwaysShow: true,
      component: () =>
        import("@/views/defaultProcess/carTenantChange/index.vue"),
      name: "tenantProcess",
      meta: {
        title: "임차인 미납처리",
      },
      children: [
        {
          path: "tenantGroupProcess",
          component: () =>
            import(
              "@/views/defaultProcess/carTenantChange/CarTenantChangeGroupMainManange.vue"
            ),
          name: "tenantGroupProcess",
          meta: {
            title: "그룹처리",
          },
        },
        {
          path: "tenantEachProcess",
          component: () =>
            import(
              "@/views/defaultProcess/carTenantChange/CarTenantChangeMainManage.vue"
            ),
          name: "tenantEachProcess",
          meta: {
            title: "개별처리",
          },
        },
        {
          path: "tenantDropGroupProcess",
          component: () =>
            import(
              "@/views/defaultProcess/carTenantChange/CarTenantChangeDropGroupMainManage.vue"
            ),
          name: "tenantDropGroupProcess",
        },
        {
          path: "tenantDownGroupProcess",
          component: () =>
            import(
              "@/views/defaultProcess/carTenantChange/CarTenantChangeDownGroupMainManage.vue"
            ),
          name: "tenantDownGroupProcess",
        },
        {
          path: "tenantGroupDetailProcess",
          component: () =>
            import(
              "@/views/defaultProcess/carTenantChange/detail/CarTenantChangeGroupDetailMainManage.vue"
            ),
          name: "tenantGroupDetailProcess",
        },
      ],
    },
    {
      path: "commissionChange",
      component: () =>
        import("@/views/defaultProcess/commission/CommissionMainMange.vue"),
      name: "commissionChange",
      meta: {
        title: "압류촉탁 관리",
      },
    },
    {
      path: "lossProcess",
      component: () =>
        import("@/views/defaultProcess/lossCheck/LossCheckMainManage.vue"),
      name: "lossProcess",
      meta: {
        title: "결손처리 관리",
      },
    },

    // {
    //   path: "templateCheck",
    //   component: () =>
    //     import("@/views/defaultProcess/PDF/PdfProcessPublicNoticeImage.vue"),
    //   name: "templateCheck",
    //   meta: {
    //     title: "템플릿확인",
    //   },
    // },
    {
      path: "billManageSend",
      component: () => import("@/views/bill/BillPostManage.vue"),
      name: "billManageSend",
      meta: {
        title: "고지서 발송관리",
      },
    },
    {
      path: "defaultProcessDetail",
      component: () =>
        import(
          "@/views/defaultProcess/detail/DefaultProcessInformationDetail.vue"
        ),
      name: "defaultProcessDetail",
    },
    {
      path: "defaultCarInformationDetail",
      component: () =>
        import("@/views/defaultProcess/detail/DefaultCarInformationDetail.vue"),
      name: "defaultCarInformationDetail",
    },
    // {
    //   path: "unpaidSMSTemplate",
    //   component: () =>
    //     import("@/views/defaultProcess/sms/UnpaidSMSTamplateMainManage.vue"),
    //   name: "unpaidSMSTemplate",
    // },
    {
      path: "cancelProcess",
      component: () =>
        import(
          "@/views/defaultProcess/cancelProcess/CancelProcessMainManage.vue"
        ),
      name: "cancelProcess",
      meta: {
        title: "미납 삭제관리",
      },
    },
  ],
};

export default outstandingAmount;
